<script lang="ts">
	import { fade } from 'svelte/transition'
  import { createEventDispatcher } from "svelte"
  import { _ } from 'svelte-i18n'

  import ReportSuccess from '../../../../../../../public/svg/report-success.svg'

  export let title = $_('report')
  export let subtitle = $_('reportModalTitle')
  export let onlyFirstScreen = false

  const dispatch = createEventDispatcher<{  
    'report': { report: boolean } 
  }>()

  let isSendReport: boolean = false

  const close = (): void => {
    dispatch('report', { report: false })
  }
  
  const reportComment = (): void => {
    isSendReport = true

    dispatch('report', { report: true })
  }
</script>

<div class="modal" transition:fade>
  <div class="modal-content">  
    <div class="title">
      { isSendReport && !onlyFirstScreen ? $_('reportSuccessTitle') : title }
    </div>

    <div class="subtitle">
      {#if isSendReport && !onlyFirstScreen}
        <ReportSuccess />
      {:else}
        {subtitle}
      {/if}
    </div>

    <div class="actions">
      <div 
        class="action" 
        on:click={close}
      >
        { isSendReport && !onlyFirstScreen ? $_('close') : $_('no') }
      </div>
      
      {#if !isSendReport || onlyFirstScreen}
        <div 
          class="action blue-color" 
          on:click={reportComment}
        >
          {$_('yes')}
        </div>
      {/if}
    </div>
  </div>
</div>

<style lang="scss">
  .modal {
    position: fixed; 
    z-index: 111111111111111111;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgb(0,0,0);
    background-color: #22252CB2;

    .modal-content {
      background-color: #fefefe;
      padding: 20px;
      box-sizing: border-box;
      border: 1px solid #888;
      max-width: 630px;
      width: 100%;
      border-radius: 10px;
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      @media (max-width: 576px) {
        max-width: 290px;
        padding: 16px;
      }

      .title {
        font-size: 20px;
        font-weight: 600;
        line-height: 29px;
        color: #30333D;
        text-align: center;
      }

      .subtitle {
        color: #5A5F6D;
        font-size: 16px;
        font-weight: 400;
        line-height: 23px;
        margin-top: 8px;
        text-align: center;
      }

      .actions {
        display: flex;

        .action {
          border: 2px solid #2B50ED;
          border-radius: 30px;
          margin-top: 16px;
          cursor: pointer;
          width: 100px;
          height: 52px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 14px;
          font-weight: 600;
          line-height: 20px;
          color: #2B50ED;
          box-sizing: border-box;

          &.blue-color {
            background-color: #2B50ED;
            color: white;
          }

          &:nth-child(2) {
            margin-left: 20px;
          }
        }
      }
    } 
  }
</style>